/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Input Event Icon component.
 */
export const InputEventIcon = ({color = '#8C18F2'}: IconProps) => {
  const {iconColor} = useIconDLS({color});

  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fillRule='evenodd' clipRule='evenodd' d='M8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C13.9964 4.68781 11.3122 2.00367 8 2Z' fill='white'/>
      <path fillRule='evenodd' clipRule='evenodd' d='M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2.00371 11.3122 4.68783 13.9963 8 14Z' fill={iconColor}/>
      <path d='M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z' fill={iconColor}/>
      <path d='M6 4.66602C5.39235 5.0022 4.88738 5.48752 4.53618 6.07286C4.18499 6.65819 4 7.32275 4 7.99935C4 8.67595 4.18499 9.34055 4.53618 9.92588C4.88738 10.5112 5.39235 10.9965 6 11.3327' stroke='white' strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round'/>
      <path d='M10 4.66602C10.6077 5.0022 11.1126 5.48752 11.4638 6.07286C11.815 6.65819 12 7.32275 12 7.99935C12 8.67595 11.815 9.34055 11.4638 9.92588C11.1126 10.5112 10.6077 10.9965 10 11.3327' stroke='white' strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round'/>
      <path d='M8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9Z' fill='white' stroke='white'/>
    </svg>
  );
};

export default InputEventIcon;
